import React, { useState } from "react";
import api from "@/lib/api";
import { DOC_TYPES, DOC_MODALIDADE } from "@/lib/status";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

/** Envio de documento do cliente (mesma rota POST /clients/{id}/documents usada no cadastro). */
export function EnviarDocumentoDialog({ open, onClose, clienteId, onDone }) {
  const [tipo, setTipo] = useState(DOC_TYPES[0]);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const mod = DOC_MODALIDADE[tipo];
  const enviar = async () => {
    if (!file) { toast.error("Selecione um arquivo"); return; }
    setBusy(true);
    const fd = new FormData(); fd.append("tipo", tipo); fd.append("modalidade", mod || ""); fd.append("file", file);
    try { await api.post(`/clients/${clienteId}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Documento enviado — pendente de análise"); setFile(null); onDone?.(); onClose(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao enviar documento"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="enviar-doc-dialog">
        <DialogHeader><DialogTitle>Enviar Documento</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Tipo de documento</Label>
            <Select value={tipo} onValueChange={setTipo}><SelectTrigger data-testid="doc-tipo-select" className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>{DOC_TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent></Select></div>
          <div><Label>Arquivo {mod === "digital" ? "(somente PDF oficial)" : mod === "foto" ? "(imagem JPG/PNG)" : ""}</Label>
            <Input type="file" accept={mod === "digital" ? "application/pdf,.pdf" : mod === "foto" ? "image/*" : "image/*,.pdf"} onChange={(e) => setFile(e.target.files[0])} data-testid="doc-file-input" className="mt-1" /></div>
        </div>
        <DialogFooter><Button onClick={enviar} disabled={busy} data-testid="doc-upload-confirm" className="bg-onyx text-white">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
